'use client'

import type { HTMLAttributeAnchorTarget } from 'react'
import { usePathname } from 'next/navigation'

export function useIsActive(href: string, target?: HTMLAttributeAnchorTarget) {
  const pathname = usePathname()
  const url = new URL(href)
  const isExternal = target === '_blank'
  const isActive = !isExternal && pathname !== '/' && pathname.includes(url.pathname)

  return isActive
}
